import { loadable } from '@shared/core/loadableFromNamedExport';

export const PriceAlertModal = loadable(() => import('@shared/components/PriceAlertModal'), 'PriceAlertModal');
